import React, { PureComponent } from 'react';
import Tooltip from '../tooltip';
import styles from './cluster-headline-and-tooltip.scss';
import Button from '../button';
import * as selectors from '../../reducers';
import { connect } from 'react-redux';

class ClusterHeadlineAndToolTip extends PureComponent {
  constructor() {
    super();
    this.state = { clusterTooltipVisible: false, clusterTooltipHover: false };

    this.showClusterTooltip = this.showClusterTooltip.bind(this);
    this.hideClusterTooltip = this.hideClusterTooltip.bind(this);
    this.handleTooltipMouseOver = this.handleTooltipMouseOver.bind(this);
    this.handleTooltipMouseLeave = this.handleTooltipMouseLeave.bind(this);
  }

  handleTooltipMouseOver() {
    this.setState({ clusterTooltipHover: true });
  }

  handleTooltipMouseLeave() {
    this.setState({ clusterTooltipHover: false });
  }

  showClusterTooltip(d) {
    if (this.props.activeProject) return;
    this.setState({
      clusterTooltipVisible: true,
    });
  }

  hideClusterTooltip(e) {
    if (this.props.activeProject) return;
    this.setState({ clusterTooltipVisible: false });
  }

  renderButton() {
    const { link, title } = this.props;
    return link ? (
      <Button
        link={link}
        gaEvent={{
          event: 'Cluster learn more click',
          params: { event_label: title },
        }}
      />
    ) : (
      ''
    );
  }

  renderClusterTooltip() {
    const { clusterTooltipVisible, clusterTooltipHover } = this.state;
    const { data, title, activeTab } = this.props;
    if (activeTab === 'By Priority') return null;
    return (
      <Tooltip
        isVisible={clusterTooltipVisible || clusterTooltipHover}
        top={-15}
        onMouseEnter={this.handleTooltipMouseOver}
        onMouseLeave={this.handleTooltipMouseLeave}
      >
        <div className={styles.tooltipInner}>
          <div className={styles.tooltipContent}>
            <h3 className={styles.tooltipHeading}>{title}</h3>
            <p className={styles.tooltipDesc}>{data.length} projects</p>
            {this.renderButton()}
          </div>
        </div>
      </Tooltip>
    );
  }
  render() {
    const { title, tabChangeRequested } = this.props;
    return (
      <h3
        className={`${styles.chartHeading} ${tabChangeRequested
          ? styles.chartHeadingLeaving
          : ''}`}
        onMouseEnter={this.showClusterTooltip}
        onMouseLeave={this.hideClusterTooltip}
      >
        {title}
        {this.renderClusterTooltip()}
      </h3>
    );
  }
}
const mapStateToProps = state => ({
  budgets: selectors.getBudgets(state),
  activeTab: selectors.getActiveTab(state),
  activeProject: selectors.getActiveProject(state),
  tabChangeRequested: selectors.tabChangeRequested(state),
});
export default connect(mapStateToProps)(ClusterHeadlineAndToolTip);



// WEBPACK FOOTER //
// ./src/components/cluster-headline-and-tooltip/cluster-headline-and-tooltip.js